import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const homeTableFields: MapSearchInput['path'] = {
    date: ['createdAt', 'paymentOrderedAt', 'dueDate', 'receivable.expectedInvoiceDueDate'],
    name: [
        'invoice.debtorName',
        'invoice.debtorIdentifier.value',
        'invoice.invoiceNumber',
        'repaymentReference',
        'id',
        'receivable.id',
        'receivable.debtorIdentifier.value'
    ],
    number: ['amount', 'invoice.invoiceNumber'],
    exact: 'invoice.invoiceNumber'
}
